"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEnums_1 = require("../core/eventTypes/EventEnums");
exports.default = (function (_a) {
    var _b = _a === void 0 ? {} : _a, getEventContext = _b.getEventContext, pushEvent = _b.pushEvent, createEventObject = _b.createEventObject, createEventClientDetails = _b.createEventClientDetails, createEventIntegratorContext = _b.createEventIntegratorContext;
    return {
        pushEvent: ContentDownloadV2,
    };
    /**
     * @param {array} content - is required
     */
    function createEventData(_a) {
        var _b = _a === void 0 ? {} : _a, userId = _b.userId, clientDetails = _b.clientDetails, content = _b.content, integratorContext = _b.integratorContext;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var eventContext = getEventContext();
        var data = {
            userId: userId || eventContext.userId,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientDetails: createEventClientDetails(clientDetails),
            content: content,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            integratorContext: createEventIntegratorContext(integratorContext),
        };
        return data;
    }
    /**
     * @param {array} content - is required
     * @param {object} clientDetails - optional
     * @param {string} clientDetails.productArea optional
     */
    function ContentDownloadV2(_a) {
        var _b = _a === void 0 ? {} : _a, userId = _b.userId, clientDetails = _b.clientDetails, content = _b.content, integratorContext = _b.integratorContext;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var newEventObject = createEventObject({
            type: EventEnums_1.EVENT_TYPES.ContentDownload,
            eventVersion: EventEnums_1.EVENT_VERSIONS.ContentDownloadV2,
            data: createEventData({ userId: userId, clientDetails: clientDetails, content: content, integratorContext: integratorContext }),
        });
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pushEvent(newEventObject);
    }
});
//# sourceMappingURL=ContentDownloadV2.js.map